<template>
    <div>
        <v-card flat class="pa-4 bar">
            <div class="d-flex justify-end align-center">
				<v-btn 
					small 
					class="btn-save"
					@click="manageprint"
				>
					<v-icon>
						mdi-printer
					</v-icon>
				</v-btn>
				<v-btn 
					small 
					class="btnclean ml-2"
					@click="manageprintNew"
				>
					<v-icon>
						mdi-printer
					</v-icon>
				</v-btn>
				<v-btn 
					small 
					class="btn-save ml-2"
					@click="getData()"
				>
					<v-icon>
						mdi-magnify
					</v-icon>
				</v-btn>
            </div>
        </v-card> 

        <v-row class="mx-1 mt-5">
            <v-col cols="12" md="6">
                <v-select
                    v-model="search.month"
                    :items="monthList"
                    item-text="text"
                    item-value="value"
                    label="Mes"
                    outlined
                    attach
                    dense
                ></v-select>
            </v-col>
            <v-col cols="12" md="6">
                <v-text-field
                    v-model="search.year"
                    label="Año"
                    outlined
                    type="number"
                    attach
                    dense
                    clearable
                ></v-text-field>
            </v-col>
        </v-row>

		<v-row class="mx-1 mt-2">
			<form style="display: flex; flex-direction: row; align-items: center; gap: 40px;">
				<div class="book-radio">
					<label for="consolidated">
						<input
							type="radio" name="booktype" id="consolidated"
							v-model="DailyMayorBookType" value="consolidated"
							class="custom-radio"
						/>
						<span class="custom-radio"></span>
						Cuentas de mayor
					</label>
				</div>
				<div class="book-radio">
					<label for="detailed">
						<input
							type="radio" name="booktype" id="detailed"
							v-model="DailyMayorBookType" value="detailed"
							class="custom-radio"
						/>
						<span class="custom-radio"></span>
						Cuentas de detalle
					</label>
				</div>
			</form>
		</v-row>

        <DxDataGrid 
			v-if="DailyMayorBookType === 'consolidated'"
			:dataSource="DataTable1"
			:showBorders="true"
			:scrolling="{ useNative: true }"    
			:column-auto-width="true"
        >
            <DxColumn width="10%" dataField="main_column" caption="Fecha" />
            <DxColumn width="32%" dataField="concept" caption="Concepto" />
            <DxColumn width="10%" dataField="ID_Accounting_Item" caption="Cuenta" />
			<DxColumn width="12%" dataField="initial_balance" caption="Inicial" />
            <DxColumn width="12%" dataField="charges" caption="Cargo" />
            <DxColumn width="12%" dataField="payments" caption="Abono" />
            <DxColumn width="12%" dataField="current_balance" caption="Saldo" />
            <DxPager :showPageSizeSelector="true" :allowedPageSizes="[5, 10, 20]" />
            <DxPaging :defaultPageSize="10" />
        </DxDataGrid>
        <DxDataGrid 
			v-else
			:dataSource="DataTable2"
			:showBorders="true"
			:scrolling="{ useNative: true }"    
			:column-auto-width="true"
        >
			<DxColumn width="10%" dataField="main_column" caption="Fecha" />
            <DxColumn width="32%" dataField="concept" caption="Concepto" />
			<DxColumn width="10%" dataField="ID_Accounting_Item" caption="Cuenta" />
            <DxColumn width="12%" dataField="initial_balance" caption="Inicial" />
            <DxColumn width="12%" dataField="charges" caption="Cargo" />
            <DxColumn width="12%" dataField="payments" caption="Abono" />
            <DxColumn width="12%" dataField="current_balance" caption="Saldo" />
            <DxPager :showPageSizeSelector="true" :allowedPageSizes="[5, 10, 20]" />
            <DxPaging :defaultPageSize="10" />
        </DxDataGrid>
        <alerts
			v-if="alert.show"
			v-on:close_alert="closeAlert"
			v-on:accept_alert="acceptAlert"
			:properties="alert"
		></alerts>
		<PrintMayorDailyBookNew :dataProps="printNew"></PrintMayorDailyBookNew>
    </div>
</template>

<script>
import {DxDataGrid, DxPager, DxPaging, DxColumn} from 'devextreme-vue/data-grid';
import PrintMayorDailyBookNew from '../../../components/ReportsAndPrintings/PrintMayorDailyBookNew.vue';
import { openMayorDailyBookPdf } from '../../../components/ReportsAndPrintings/PrintMayorDailyBookPdf';
import alerts from '@/components/Alerts.vue';

export default {
	name: "Book",
	components: {
		DxDataGrid,
		DxPager,
		DxPaging,
		DxColumn,
		PrintMayorDailyBookNew,
		alerts
	},
	props: ['win'],
	data() {
		return {
			printNew: {},
			DataTable1: [],
			DataTable2: [],
			DailyMayorBookType: 'consolidated',
			panel: 0,
			tab: null,
			key: 0,
			search:{
				month: null,
				year: String(new Date().getFullYear()),
			},
			alert: {
				type: "success",
				show: false,
				header: "",
				body: "",
			},
			monthList: [
				{text: 'Enero', value: 1},
				{text: 'Febrero', value: 2},
				{text: 'Marzo', value: 3},
				{text: 'Abril', value: 4},
				{text: 'Mayo', value: 5},
				{text: 'Junio', value: 6},
				{text: 'Julio', value: 7},
				{text: 'Agosto', value: 8},
				{text: 'Septiembre', value: 9},
				{text: 'Octubre', value: 10},
				{text: 'Noviembre', value: 11},
				{text: 'Diciembre', value: 12},
			],
			Currency: JSON.parse(localStorage.getItem('branch')).Currency,
			searchbusiness: {},
			infobusiness: {},
			currencyCols: ['initial_balance', 'charges', 'payments', 'current_balance', 'Exportaciones', 'VentaCuentasTerceros', 'IVACuentasTerceros'],
		}
	},
	computed:{
		columnWidth() {
			return this.$vuetify.breakpoint.smAndDown ? '150px' : 'auto !important';
		},
	},
	mounted() {
		this.searchbusiness.branch = JSON.parse(localStorage.getItem("user")).branch || "";
		this.searchbusiness.business = JSON.parse(localStorage.getItem("user")).businessid || "";
		this.getInfoBusiness()
	},
	methods: {
		async getInfoBusiness() {
			let response = await this.$API.branches.findSpecificBranch(this.searchbusiness)
			this.infobusiness = response[0]
		},
		closeAlert() {
			this.alert.show = false;
		},
		acceptAlert() {
			this.alert.show = false;

			if (this.alert.options == "deletecustomer") {
				this.deleteCustomer();
			}
		},
		async getData() {
			if(this.search.month == null || this.search.year == null){
				this.showAlert("danger", "Error", "Debe seleccionar un mes y un año");
				return;
			}
			if(this.search.year.length != 4){
				this.showAlert("danger", "Error", "El año debe tener 4 digitos");
				return;
			}
			this.search.typeData = this.DailyMayorBookType == 'consolidated'? 1 : 0;
			let response = await this.$API.accountingreports.getGeneralJournalData(this.search)

			if (response.length > 0) {
				const dataMap = response.map(e => ({...e, main_column: e.accounting_entry_date ?? e.main_column }));
				this.DataTable1 = dataMap
				this.DataTable2 = dataMap
			}
			else {
				this.DataTable1 = []
				this.DataTable2 = []
			}

			/*let response2 = await this.$API.accountingreports.getGeneralDetailJournalData(this.search)

			if (response2.length > 0) {
				this.DataTable2 = response2
			}
			else {
				this.DataTable2 = []
			}*/
		},
		showAlert(type, header, body, options = null) {
			type = type == null ? "danger" : type;
			this.alert.type = type;
			this.alert.header = header;
			this.alert.body = body;
			this.alert.show = true;
			this.alert.options = options != null ? options : null;
		},
		setupData(data){
			this.DataTable = data.map((item,index) => {
				return {
					...item,
					numberAccount: index + 1,
					account_code: item.account_code,
					account_description: item.account_description,
					deb: item.debe,
					hab: item.haber,
					debe: this.Currency + " " + item.debe.toFixed(2), 
					haber: this.Currency + " " + item.haber.toFixed(2),
				}
			})
		},
		getLedger(){
			if(this.search.month == null || this.search.year == null){
				this.showAlert("danger", "Error", "Debe seleccionar un mes y un año");
				return;
			}
			if(this.search.year.length != 4){
				this.showAlert("danger", "Error", "El año debe tener 4 digitos");
				return;
			}
			this.$API.accountingreports.getGeneralLedgerByDate(this.search)
			.then((response) => {
				if(response.data.accountingCatalog.length > 0){
					this.setupData(response.data.accountingCatalog);
				}
				else{
					this.DataTable = [];
				}
			})
			.catch((err) => {
				console.log(err);
			})
		},
		/**
		 * Convierte una cadena de moneda a un número.
		 * @param {string} currencyStr - La cadena de moneda.
		 * @returns {number} El valor numérico.
		 */
		toNumeric(currencyStr) {
			if (typeof currencyStr !== 'string') return 0;
			// Elimina el '$' y cualquier coma, luego parsea a float.
			return parseFloat(currencyStr.replace('$', '').replace(/,/g, ''));
		},

		/**
		 * Formatea un número como cadena de moneda.
		 * @param {number} num - El valor numérico.
		 * @returns {string} La cadena de moneda formateada.
		 */
		formatCurrency(num) {
			const formatted = new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: 'USD',
				minimumFractionDigits: 2
			}).format(num);
			// Ajuste para el formato de saldo negativo a "-$X.XX"
			if (num < 0 && formatted.startsWith("($")) {
				return `-${formatted.replace('(', '$').replace(')', '')}`;
			}
			return formatted;
		},

		/**
		 * Agrupa y suma los datos por la clave de cuenta original y luego por fecha contable.
		 * @param {object} inputData - Los datos originales agrupados por código de cuenta.
		 * @returns {object} Los datos agrupados por la clave de cuenta original y su fecha.
		 */
		aggregateDataByDateAndOriginalKey(inputData) {
			let finalResult = [];

			for (let index = 0; index < inputData.length; index++) {
				let element = inputData[index];
				if (element.last === true) {
					for (const col of this.currencyCols) {
						element[col] = this.toNumeric(element[col]);
						element[col] = this.formatCurrency(element[col]);
					}
					finalResult.push(element);
					continue;
				}
				
				const indexItem = finalResult.findIndex(item => 
					item.main_column === element.main_column && 
					item.account_code === element.account_code
				);

				if (indexItem === -1) {
					let item = {
						...element,
						initial_balance: 0,
						charges: 0,
						payments: 0,
						current_balance: 0,
						Exportaciones: 0,
						VentaCuentasTerceros: 0,
						IVACuentasTerceros: 0,
					}
					for (const col of this.currencyCols) {
						item[col] += this.toNumeric(element[col]);
					}
					finalResult.push(item);
				} else {
					for (const col of this.currencyCols) {
						finalResult[indexItem][col] += this.toNumeric(element[col]);
					}
				}
			}
			finalResult = finalResult.map(data => {
				const formattedData = { ...data };
				if (!formattedData.last) {
					for (const col of this.currencyCols) {
						formattedData[col] = this.formatCurrency(data[col]);
					}
				}
				return formattedData;
			});
			return finalResult;
		},
		manageprint() {
			let branchinfo = JSON.parse(localStorage.getItem("branch"));

			const body = this.DailyMayorBookType == 'consolidated' ? this.DataTable1 : this.DataTable2;
			openMayorDailyBookPdf({
				data: {
					body,
					branch: branchinfo,
					business: this.infobusiness,
					date: this.search,
					bookType: this.DailyMayorBookType,
				},
			});
		},
		modifyTable(table) {
			const body = table;
			let newBody = [];

			for (let index = 0; index < body.length; index++) {
				let current = body[index];
				if (index === 0 || body[index - 1].account_code !== current.account_code) {
					current = {...current, first: true};
					newBody.push(current);
				} else {
					newBody.push(current);
				}
				const lastIndex = newBody.findLastIndex(item => item.first === true);
				if (index > 0 && index < body.length - 1 && 
					current.account_code !== body[index + 1].account_code
					|| body.length === index + 1
				) {
					let newElement = {...newBody[lastIndex], last: true};
					delete newElement.first;
					newBody.push(newElement);
				}
			}

			return this.aggregateDataByDateAndOriginalKey(newBody);
		},
		async manageprintNew() {
			let branchinfo = JSON.parse(localStorage.getItem("branch"));
			
			if (this.DailyMayorBookType == 'consolidated') {
				this.printNew = {
					show: true,
					data: {
						body: this.DailyMayorBookType == 'consolidated' ? this.modifyTable(this.DataTable1) : this.modifyTable(this.DataTable2),
						branch: branchinfo,
						business: this.infobusiness,
						date: this.search,
						bookType: this.DailyMayorBookType,
					},
				};
			}
			else {
				this.printNew = {
					show: true,
					data: {
						body: this.modifyTable(this.DataTable2),
						branch: branchinfo,
						business: this.infobusiness,
						date: this.search,
						bookType: this.DailyMayorBookType,
					},
				};
			}
		}
	},
}
</script>

<style>
.book-radio {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
	font-size: 16px;
	color: black;
	margin: 0 0 20px 12px;
}
.book-radio label {
	cursor: pointer;
}
.book-radio input[type="radio"] {
        display: none;
    }
.book-radio .custom-radio {
	width: 20px;
	height: 20px;
	border: 2px solid #777;
	border-radius: 50%;
	display: inline-block;
	position: relative;
	cursor: pointer;
	transition: background-color 0.3s;
	align-self: center;
}
.book-radio .custom-radio::before {
	content: '';
	width: 12px;
	height: 12px;
	border-radius: 50%;
	background-color: transparent;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	transition: background-color 0.3s;
}
.book-radio input[type="radio"]:checked + .custom-radio::before {
	background-color: #3498DB;
}
.book-radio label {
    display: flex;
	gap: 8px;
    align-items: center;
}
</style>

<style scoped>
.bar {
  max-width: 100%;
  background-color: rgb(60, 60, 60) !important;
  color: white !important;
  border-style: solid;
  border-color: black;
  border-radius: 15px !important;
  margin: 16px 12px !important;
}
.btn-add{
  background-color: #3498DB  !important;
  color: white;
}
.btnsave{
  background-color: #00A178 !important;
  color: white;
}
.btnclean{
  background-color: #F29D35 !important;
  color: white;
}
.btndelete{
  background-color: #E3191E !important;
  color: white;
}
</style>
